// Variables below should be read from process.env

const pageUrl = new URL(window.location.href);
const eventSignupId = pageUrl.searchParams.get('event_id');

const defaultDomain = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3000'
  : 'https://www.yousty.ch';
const domain = process.env.REACT_APP_API_HOST || defaultDomain;

const apiConfig = {
  eventSignupId,
  baseUrl: `${domain}/api/v1/conventions/events/${eventSignupId}`,
  baseUrlv2: `${domain}/api/v2/conventions/events/${eventSignupId}`,
  auth: {
    user: 'yapi',
    password: 'youapi123',
  },
};

const imgix = {
  imgix_domain:
    process.env.NODE_ENV === 'development'
      ? 'yousty-stage-eu.imgix.net'
      : 'yousty-switzerland.imgix.net',
  s3_domain_to_replace:
    process.env.NODE_ENV === 'development'
      ? 's3-eu-west-1.amazonaws.com/yousty-stage-eu'
      : 's3-eu-west-1.amazonaws.com/yousty-switzerland',
  imgix_parameters_main: '?w=180&h=270&fit=crop&crop=entropy&q=75',
  imgix_parameters_student: '?w=90&h=135&fit=crop&crop=entropy&q=75',
};

export default apiConfig;
export { domain, imgix };



// WEBPACK FOOTER //
// ./src/lib/env.js